import React, { useEffect, useContext, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';

import TabContainer from 'containers/TabContainer/TabContainer';
import ContextStore from 'modules/context';

function SettingMerchandise() {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { setBreadcrumbs } = useContext(ContextStore)
  const location = useLocation()
  const pathname = location.pathname
  const [activeTabIndex, setActiveTabIndex] = useState(undefined)

  useEffect(() => {
    setBreadcrumbs([{
      text: formatMessage({ id: 'sideMenu.setting.root' })
    }])
  }, [pathname]);

  useEffect(() => {
    if (pathname === '/setting/merchandise/category' && activeTabIndex !== 0) {
      setActiveTabIndex(0)
    }

    return () => {
    };
  }, [pathname]);

  const onTabSelected = (tabIndex) => {
    if (tabIndex === 0) {
      navigate('/setting/merchandise/category');
    }
  }

  const tabs = [
    {
      label: formatMessage({ id: 'settingMerchandise.category.title' }),
      component: <Outlet />
    },
  ]

  return (
    <div style={{ padding: '12px 24px 80px 24px' }}>
      <Toolbar sx={{ pl: 2, pr: 1 }}>
        <Typography sx={{ flex: '1 1 100%', flexShrink: 2 }} variant="h6" id="tableTitle" component="div">
          <FormattedMessage id="settingMerchandise.title" />
        </Typography>
      </Toolbar>
      <TabContainer activeTabIndex={activeTabIndex} defaultSelect={0} tabs={tabs} onTabSelected={onTabSelected} />
    </div>
  );
}

export default SettingMerchandise;
